const imageLoad = function (img) {
  return new Promise((resolve, reject) => {
    if (img.complete) {
      resolve()
    } else {
      img.onload = function (event) {
        resolve(event)
      }

      img.onerror = function (err) {
        reject(err)
      }
    }
  })
}

export const imageCenter = (domList, mode) => {
  domList.forEach( (item) => {
    const img = item.children[0]
    const itemW = item.offsetWidth
    const itemH = item.offsetHeight
    const itemR = itemW / itemH

    imageLoad(img).then( () => {
      const imgW = img.naturalWidth
      const imgH = img.naturalHeight
      const imgR = imgW / imgH

      let resultMode = null

      switch (mode) {
        case 'aspectFill':
          resultMode = imgR > 1 ? 'aspectFill-x' : 'aspectFill-y'
          break
        case 'wspectFill':
          resultMode = itemR > imgR ? 'aspectFill-x' : 'aspectFill-y'
          break
        default:
      }

      $(img).addClass(resultMode)
    })
  })
}
